import { lazy } from 'react';

const CreditMemoRequest = lazy(() =>
  import('../pages/CreditMemoRequest/index.js').then((module) => ({
    default: module.CreditMemoRequest,
  })),
);

const CreditMemoRequestForm = lazy(() =>
  import('../pages/CreditMemoRequest/form.js').then((module) => ({
    default: module.CreditMemoRequest,
  })),
);

const creditMemoRequestRoute = {
  public: [],
  auth: [
    {
      name: 'credit_memo_request',
      path: '/credit-and-collections/management/memo-credit/credit-memo-requests',
      component: CreditMemoRequest,
    },
    {
      name: 'credit_memo_request_form',
      path: '/credit-and-collections/management/memo-credit/credit-memo-requests/create',
      component: CreditMemoRequestForm,
    },
    {
      name: 'credit_memo_request_edit_form',
      path: '/credit-and-collections/management/memo-credit/credit-memo-requests/:id',
      component: CreditMemoRequestForm,
    },
  ],
};

export default creditMemoRequestRoute;
